import clsx from 'clsx'
import React, {useContext} from 'react'
import {useHistory} from 'react-router-dom'
import {makeStyles} from 'external/material'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'

import create from 'helpers/command'
import {initQuestion} from 'helpers/quiz'

import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'


const useStyles = makeStyles(addQuestionStyles)

export default function AddQuestion() {

  const classes = useStyles()
  const context = useContext(TeacherContext)
  const history = useHistory()
  const {translate, quizQuestionTypes, updateState, link, linkQuery} = context

  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  async function addQuestion (questionType) {
    const [data] = await create('quiz', 'generateQuestion')({type: questionType.id})
    if (data) {
      const init = initQuestion(context)
      updateState({quizNewBankQuestion: {$set: init({...data, isNew: true})}})
      history.push(link({questionId: data.id, sectionName: 'new-question'}, '/:languageId/:role/:page/:tab/:sectionName/:questionId'))
    }
    handleClose()
  }

  return (
    <Box className={classes.root}>
      <Button className={classes.button} startIcon={<AddIcon />} onClick={handleClick}>{translate('add-to-question-bank')}</Button> 
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {quizQuestionTypes.map((type, index) => (
          <MenuItem key={index} onClick={() => addQuestion(type)}>{translate(type.name)}</MenuItem>
        ))}
      </Menu>
    </Box>
  )
}

function addQuestionStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: 16
    },
    button: {
      padding: '4px 10px',
      backgroundColor: '#2ca5ec',
      color: '#fff',
      textTransform: 'capitalize',
      '& .MuiButton-startIcon': {
        marginRight: 3
      },
      '&:hover': {
        backgroundColor: '#12608e'
      }
    }
  }
}
